import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    adminToken: localStorage.getItem('admin_token') || ''
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.adminToken = token
      localStorage.setItem('admin_token', token)
    },
    CLEAR_TOKEN(state) {
      state.adminToken = ''
      localStorage.removeItem('admin_token')
    }
  },
  actions: {
    login({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    logout({ commit }) {
      commit('CLEAR_TOKEN')
    }
  },
  getters: {
    isAuthenticated: state => !!state.adminToken
  }
})
